<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @enter-cancelled="enterCancelled"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
    @leave-cancelled="leaveCancelled"
  >
    <div
      v-show="innerVisible"
      class="km-modal__wrapper"
      @click.self="handleBackdropClick"
    >
      <div
        ref="modal"
        class="km-modal"
        :class="modalCss"
        :style="modalStyle"
      >
        <div class="km-modal__header">
          <div
            v-if="title"
            class="km-modal__title"
          >
            <k-icon
              v-if="icon"
              :class="titleIconCss"
              circle
              :icon="icon"
            />
            <slot name="title">
              <div class="km-modal__title-inner">
                {{ title }}
              </div>
            </slot>
          </div>
          <k-button
            v-if="showClose && !plain"
            class="km-modal__close-btn"
            type="light"
            size="normal"
            circle
            plain
            @click="handleClose"
          >
            <k-icon icon="times" />
          </k-button>
        </div>
        <div
          v-if="rendered"
          class="km-modal__body"
        >
          <k-button
            v-if="showClose && plain"
            class="km-modal__close-btn"
            type="light"
            size="large"
            circle
            plain
            @click="handleClose"
          >
            <k-icon icon="times" />
          </k-button>
          <slot />
        </div>
        <div
          v-if="$slots.footer"
          class="km-modal__footer"
        >
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import ModalManager from './ModalManager'
import $ from 'jquery'
import modalMixin from './ModalMixin'
import KFocused from '../../core/mixins/focused/KFocused'
import { getCorrectEventName } from '../../core/utils'
import { window, document } from 'ssr-window'

const animationEnd = getCorrectEventName(window, 'animationend')

export default {
  name: 'KModal',
  mixins: [modalMixin, KFocused],
  model: {
    prop: 'visible',
    event: 'visible',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 标题图标
    icon: {
      type: String,
      default: '',
    },
    // 主题色
    type: {
      type: String,
      default: 'primary',
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: 'auto',
    },
    size: {
      type: String,
      default: '', // large normal small mini full
    },
    // 当[按下esc]，[点击关闭按钮]，[点击遮罩]这三种方式触发 Modal 关闭时，会触发该函数
    // 函数传递一个 done函数 做为参数，主动调用该函数才会关闭
    beforeClose: {
      type: Function,
      default: undefined,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    // 点击 esc 是否关闭模态
    keyboard: {
      type: Boolean,
      default: false,
    },
    closeOnClickBackdrop: {
      type: Boolean,
      default: true,
    },
    // 滚动条在 modal__body 内
    scrollInBody: {
      type: Boolean,
      default: false,
    },
    // 垂直居中显示
    verticalCentered: {
      type: Boolean,
      default: false,
    },
    // 使用 transition
    transition: {
      type: String,
      default: '',
    },
    // 是否属于消息框
    isMessageBox: {
      type: Boolean,
      default: false,
    },
    destroyOnHide: {
      type: Boolean,
      default: false,
    },
    // 是否展示遮罩
    mask: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // manager: ModalManager,
      // opened: false, // 已打开
      closed: false, // 已关闭
    }
  },
  computed: {
    modalCss() {
      const css = []
      if (this.visible) {
        css.push(`km-modal--open`)
      }
      if (this.plain) {
        css.push(`km-modal--plain`)
      }
      if (this.verticalCentered) {
        css.push(`km-modal--v-centered`)
      }
      if (this.isMessageBox) {
        css.push(`km-modal--message-box`)
      }
      if (!this.plain) {
        const size = this.size || 'normal'
        css.push(`km-modal--${size}`)
      }
      return css
    },
    titleIconCss() {
      return [`has-text-${this.type}`, `km-modal__title-icon`]
    },
    modalWidth() {
      if (this.width) {
        return this.width
      }

      if (this.plain) {
        return 'auto'
      }

      return null
    },
    modalStyle() {
      return {
        width: this.modalWidth,
        height: this.height,
      }
    },
  },
  watch: {
    visible() {
      const visible = this.visible
      this.$emit('visible', visible)
      if (visible) {
        document.body.appendChild(this.$el)
      }
    },
  },
  mounted() {
  },
  methods: {
    handleBackdropClick() {
      if (this.closeOnClickBackdrop) {
        this.handleClose()
      } else {
        const $modal = $(this.$refs.modal)
        $modal.addClass('animation-shake').one(animationEnd, () => {
          $modal.removeClass('animation-shake')
        })
      }
    },
    handleClose() {
      if (!this.visible) {
        return
      }
      // API
      if (this.beforeClose && typeof this.beforeClose === 'function') {
        this.beforeClose(this.doneHide)
      } else {
        this.doneHide()
      }
    },
    doneHide() {
      // API - parameter as beforeClose
      this.$emit('visible', false)
    },
  },
}
</script>
